<fieldset>
  <legend class="group-label fw-bold">{{ legendText }}</legend>
  <rfa-errors slot="validation" [control]="initialsControl"></rfa-errors>
  <rfa-errors slot="validation" [control]="insertionControl"></rfa-errors>
  <rfa-errors slot="validation" [control]="lastNameControl"></rfa-errors>

  <div class="group-container">
    <div class="group-input group-input-small">
      <crnt-form-control>
        <crnt-form-control-label slot="label">
          <label class="fw-normal" [for]="initialsControl.id">
            {{ initialsControl.options.label }}
          </label>
        </crnt-form-control-label>
        @if (initialsControl.options.helpText) {
          <crnt-form-control-help-text slot="help">
            {{ initialsControl.options.helpText }}
          </crnt-form-control-help-text>
        }
        <crnt-text-input
          [state]="initialsControl.hasError() ? 'invalid' : 'enabled'"
        >
          <input
            type="text"
            [id]="initialsControl.id"
            [name]="initialsAutocompleteId"
            [autocomplete]="initialsAutocompleteId"
            [formControl]="initialsControl"
            [wlTrackFieldfocus]="focusChangeTrackConfig(initialsControl)"
            [wlAutomationId]="initialsControl.options.dataAutomationId"
            [attr.aria-describedby]="ariaDescribedBy(initialsControl)"
          />
        </crnt-text-input>
      </crnt-form-control>
    </div>
    <div class="group-input group-input-small">
      <crnt-form-control>
        <crnt-form-control-label slot="label">
          <label class="fw-normal" [for]="insertionControl.id">
            {{ insertionControl.options.label }}
          </label>
        </crnt-form-control-label>
        @if (insertionControl.options.helpText) {
          <crnt-form-control-help-text slot="help">
            {{ insertionControl.options.helpText }}
          </crnt-form-control-help-text>
        }
        <crnt-text-input
          [state]="insertionControl.hasError() ? 'invalid' : 'enabled'"
        >
          <input
            type="text"
            [id]="insertionControl.id"
            [name]="insertionAutocompleteId"
            [autocomplete]="insertionAutocompleteId"
            [formControl]="insertionControl"
            [wlTrackFieldfocus]="focusChangeTrackConfig(insertionControl)"
            [wlAutomationId]="insertionControl.options.dataAutomationId"
            [attr.aria-describedby]="ariaDescribedBy(insertionControl)"
          />
        </crnt-text-input>
      </crnt-form-control>
    </div>
    <div class="group-input group-input-large">
      <crnt-form-control>
        <crnt-form-control-label slot="label">
          <label class="fw-normal" [for]="lastNameControl.id">
            {{ lastNameControl.options.label }}
          </label>
        </crnt-form-control-label>
        @if (lastNameControl.options.helpText) {
          <crnt-form-control-help-text slot="help">
            {{ lastNameControl.options.helpText }}
          </crnt-form-control-help-text>
        }
        <crnt-text-input
          [state]="lastNameControl.hasError() ? 'invalid' : 'enabled'"
        >
          <input
            type="text"
            [id]="lastNameControl.id"
            [name]="lastNameAutocompleteId"
            [autocomplete]="lastNameAutocompleteId"
            [formControl]="lastNameControl"
            [wlTrackFieldfocus]="focusChangeTrackConfig(lastNameControl)"
            [wlAutomationId]="lastNameControl.options.dataAutomationId"
            [attr.aria-describedby]="ariaDescribedBy(lastNameControl)"
          />
        </crnt-text-input>
      </crnt-form-control>
    </div>
  </div>
</fieldset>
